import React, { useState } from 'react';
import api from '../../../utils/api'; // ваш API клиент
import './ExportUser.css'
export const ExportUser = () => {
  const [loading, setLoading] = useState(false);
  const [exportType, setExportType] = useState('all');
  const [format, setFormat] = useState('csv');
  const [filters, setFilters] = useState({
    startDate: '',
    endDate: '',
    onlyWithSubscriptions: false,
  });

const handleExport = async () => {
  try {
    setLoading(true);
    
    const params = new URLSearchParams({
      format,
      type: exportType,
      ...filters
    });

    console.log('Запрос на экспорт с параметрами:', params.toString());
    
    // Используем ваш api клиент
    const response = await api.exportEmails(params.toString());
    
    console.log('Ответ получен:', response);
    console.log('Тип ответа:', typeof response);
    console.log('Является ли Blob:', response instanceof Blob);
    
    const date = new Date().toISOString().split('T')[0];
    const fileName = `users_emails_${exportType}_${date}.${format}`;
    
    // Создаем Blob из ответа
    const blob = response instanceof Blob 
      ? response 
      : new Blob([response], { 
          type: format === 'csv' ? 'text/csv;charset=utf-8' : 'text/plain;charset=utf-8' 
        });
    
    // Создаем ссылку для скачивания
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    
    // Используем разные способы скачивания
    document.body.appendChild(a);
    a.click();
    
    // Даем время на скачивание
    setTimeout(() => {
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
      setLoading(false);
      alert(`Файл "${fileName}" успешно скачан`);
    }, 100);
    
  } catch (error) {
    console.error('Export error:', error);
    console.error('Подробности ошибки:', error.response || error);
    alert(`Ошибка при скачивании файла: ${error.message}`);
    setLoading(false);
  }
};

  // Остальной код компонента остается без изменений...
  return (
    <div className="advanced-export">
      <div className="export-card">
        <div className="card-header">
          <h4>📤 Экспорт базы email</h4>
          <p>Выберите параметры для экспорта списка email пользователей</p>
        </div>

        <div className="card-body">
          {/* Выбор типа пользователей */}
          <div className="form-group">
            <label>Тип пользователей:</label>
            <select
              value={exportType}
              onChange={(e) => setExportType(e.target.value)}
              className="form-select"
            >
              <option value="all">Все пользователи</option> 
              <option value="active-users">Только активные</option>
              <option value="admin">Администраторы</option>
              <option value="supervisor">Супервайзеры</option>
              <option value="paid">С платными подписками</option>
              <option value="without-sub">Без подписок</option>
            </select>
          </div>

          {/* Фильтр по дате */}
          <div className="form-row">
            <div className="form-group">
              <label>Дата регистрации с:</label>
              <input
                type="date"
                value={filters.startDate}
                onChange={(e) => setFilters({...filters, startDate: e.target.value})}
                className="form-control"
              />
            </div>
            <div className="form-group">
              <label>по:</label>
              <input
                type="date"
                value={filters.endDate}
                onChange={(e) => setFilters({...filters, endDate: e.target.value})}
                className="form-control"
              />
            </div>
          </div>

          {/* Дополнительные фильтры */}
          <div className="form-group">
            <label className="checkbox">
              <input
                type="checkbox"
                checked={filters.onlyWithSubscriptions}
                onChange={(e) => setFilters({...filters, onlyWithSubscriptions: e.target.checked})}
              />
              <span>Только пользователи с активными подписками</span>
            </label>
          </div>

          {/* Выбор формата */}
          <div className="form-group">
            <label>Формат экспорта:</label>
            <div className="format-options">
              <div className="format-option">
                <input
                  type="radio"
                  id="format-csv"
                  name="format"
                  value="csv"
                  checked={format === 'csv'}
                  onChange={(e) => setFormat(e.target.value)}
                />
                <label htmlFor="format-csv">
                  <strong>CSV</strong>
                  <small>Excel, Google Sheets</small>
                </label>
              </div>
              <div className="format-option">
                <input
                  type="radio"
                  id="format-txt"
                  name="format"
                  value="txt"
                  checked={format === 'txt'}
                  onChange={(e) => setFormat(e.target.value)}
                />
                <label htmlFor="format-txt">
                  <strong>TXT</strong>
                  <small>Только email</small>
                </label>
              </div>
            </div>
          </div>

          {/* Кнопка экспорта */}
          <div className="export-action">
            <button
              onClick={handleExport}
              disabled={loading}
              className={`btn-export ${loading ? 'loading' : ''}`}
            >
              {loading ? (
                <>
                  <span className="spinner-small"></span>
                  Генерация файла...
                </>
              ) : (
                '📥 Скачать файл'
              )}
            </button>
            
            <div className="export-stats">
              <small>Приблизительное количество: ~1000 email</small>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};